/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Min_SamplesInputs */

const en_min_samples = /** @type {(inputs: Min_SamplesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min samples`)
};

const es_min_samples = /** @type {(inputs: Min_SamplesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muestras min`)
};

/**
* | output |
* | --- |
* | "Min samples" |
*
* @param {Min_SamplesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const min_samples = /** @type {((inputs?: Min_SamplesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Min_SamplesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_min_samples(inputs)
	return es_min_samples(inputs)
});